const slottingProductTabMap = Object.freeze({
  '#overview': 0,
  '#product_detail': 1,
  '#location_on_shelf': 2,
  '#sales_by_location': 3,
  '#transactions': 4,
})

export {
  slottingProductTabMap,
}



// WEBPACK FOOTER //
// ./src/router/tabMap.js